module.exports = __webpack_public_path__ + "static/media/Silver-Host-NA-Partner.2b6c33b6.png";